/**
 * shadowZones - Zonen-Definition für die Jahresübersicht (#606)
 *
 * Drei Lichtzonen im Markenton — warmes Sonnengelb / neutrales Beige / kühles
 * Graublau. Bewusst KEINE Ampelfarben: Schatten ist kein Fehler, sondern eine
 * Standortangabe. Single Point of Truth für Heatmap-Overlay, Legende und den
 * Licht-Abgleich (SunlightWarningBadge), damit alle dieselbe Sprache sprechen.
 */

export const SUN_ZONES = {
  full: { key: 'full', label: 'Vollsonnig', hint: '≥ 6 h direkte Sonne', rgb: [245, 201, 96] },
  partial: { key: 'partial', label: 'Halbschattig', hint: '3–6 h direkte Sonne', rgb: [214, 199, 168] },
  shade: { key: 'shade', label: 'Schattig', hint: '< 3 h direkte Sonne', rgb: [120, 138, 162] },
};

/** Reihenfolge für Legenden (hell → dunkel). */
export const SUN_ZONE_ORDER = ['full', 'partial', 'shade'];

/** CSS-rgb()/rgba()-String einer Zone. */
export function zoneColor(zoneKey, alpha) {
  const zone = SUN_ZONES[zoneKey];
  if (!zone) return 'transparent';
  const [r, g, b] = zone.rgb;
  return alpha == null ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
